"use client";

import { type ReactNode } from "react";
import { LocaleProvider } from "./LocaleProvider";
import { TIMEPILOT_CATALOGS } from "./timepilotCatalogs";
import { EnabledLocalesProvider } from "./EnabledLocalesProvider";

export function TimePilotLocaleProvider({
  children,
  syncHtmlLang = true,
}: {
  children: ReactNode;
  syncHtmlLang?: boolean;
}) {
  return (
    <LocaleProvider catalogs={TIMEPILOT_CATALOGS} syncHtmlLang={syncHtmlLang}>
      {children}
    </LocaleProvider>
  );
}

export function TimePilotI18nProviders({ children }: { children: ReactNode }) {
  return (
    <EnabledLocalesProvider>
      <TimePilotLocaleProvider>{children}</TimePilotLocaleProvider>
    </EnabledLocalesProvider>
  );
}
